var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconProviderAirlinePlaceholderFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 0h32v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.677 11.027c-.099-.531-.476-1.301-1.211-1.722-.426-.244-1.139-.46-2.147-.091l-2.772 1.177-5.867-3.63a.628.628 0 00-.655-.002l-.949.58a.628.628 0 00-.166.917l3.973 5.106.216.279 1.234-.45-4.007-5.151.022-.014 5.817 3.599c.015.01.033.01.048.018a.62.62 0 00.12.044c.038.01.075.019.113.022.04.003.077 0 .117-.005a.593.593 0 00.123-.025c.017-.006.035-.003.052-.01l3.038-1.293c.424-.154.784-.149 1.07.014.362.207.559.631.602.866.06.324-.931.683-1.258.8l-11.48 4.18c-.005.002-.547.215-.715-.07-.291-.493-.754-1.392-1.092-2.06l1.535.953c.177.11.397.123.586.038l2.979-1.339-.79-1.016-2.398 1.08-1.782-1.106a.624.624 0 00-.543-.057l-.787.286a.626.626 0 00-.347.864c.042.085 1.039 2.105 1.562 2.993.347.587.904.762 1.404.762.331 0 .637-.078.838-.162l5.764-2.098 5.692-2.072c.751-.272 2.315-.838 2.061-2.205z",
    fill: "#D1D1D1"
  })));
}

export default SvgIconProviderAirlinePlaceholderFilled;